
/* injects from baggage-loader */

'use strict';

import ProductVariantsController from './product.variants.controller';
import ProductVariantsTemplate from './product.variants.html';

export default class ProductVariantsComponent {
		constructor() {
				this.templateUrl = ProductVariantsTemplate;
				this.controller = ProductVariantsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					config: '<',
					product: '<',
					products: '<',
					totalItemCount: '<',
					selectedProduct	: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/product/variants/product.variants.component.js